
export const accessAuthData = (type, key, data) => {
  switch (type) {
    case "set":
      return localStorage.setItem(key, JSON.stringify(data));

    case "get": {
      const raw = localStorage.getItem(key);
      if (!raw || raw === "undefined") return null;
      try {
        return JSON.parse(raw);
      } catch {
        return raw;
      }
    }

    case "remove":
      return localStorage.removeItem(key);

    default:
      return null;
  }
};

export const accessSessionData = (type, key, data) => {
  switch (type) {
    case "setData":
      return accessAuthData("set", key, data);

    case "getdata":
      return accessAuthData("get", key);

    case "removeData":
      return accessAuthData("remove", key);

    default:
      return null;
  }
};

export const getAccessToken = () => {
  return accessAuthData("get", "access_token");
};
